import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { SharedHttpService } from 'src/app/shared/services/shared-http.service';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {

  public openNotification: boolean = false;
  contentOfNotification:any='';
  closeResult: string = '';
  notifications: any;
  notificationscount: any;
  total = 100;
  page: any = 1;
  take: number = 10;
  allNotifications:any=[]

  constructor(private sharedService: SharedHttpService, private router: Router,public toastr: NotificationService) {}

  ngOnInit() {
    this.getAllNotifications();
    this.getNotifications();
  }


  toggleNotificationMobile() {
    this.openNotification = !this.openNotification;
  }

  showNotificationData(n,e) {
    let notification = e.target.closest('li');
  
      notification.classList.add('seen');
      this.markasread(n.notificationId);
     
      let url: string = `/objections/details/${n.eObjectionRequestId}/inbox`;
      this.router.navigateByUrl('/refresh', { skipLocationChange: true }).then(() => {
        this.router.navigate([url]);
    });
    // if(n.notificationCode==2){
        // this.router.navigate([url]);
        // window.open(url); 
    // }
  }


  getAllNotifications(){
    let skip: any = this.take * (this.page - 1);
    this.sharedService.get(`GetAllNotification?Take=${this.take}&Skip=${skip}`).subscribe(res=>{
      this.allNotifications=res.data;
      this.total=res.count;
    })
  }

    getNotifications() {
      
        this.sharedService.get(`GetTop4`).subscribe(res => {
            console.log(res);
            this.toastr.notifications = res.top4Elemnts;
            if (res.countUnReaded > 0)
                this.toastr.notificationscount = res.countUnReaded;
            else
                this.toastr.notificationscount = "";
        });
    }


  markasread(notificationId:any) {
      this.sharedService.get(`MakeItSeen?NotificationId=${notificationId}`,).subscribe(a => {
          this.getNotifications();
    });
  }

}
